import { IdentityDocumentType } from 'app/constants/identityDocumentType'

export const getIdentityDocumentTypeName = (
  identityDocumentType: IdentityDocumentType,
  translate: (string) => string,
): string => {
  const text: string = IdentityDocumentType[identityDocumentType]
  return translate(`identityDocumentType.${text}`)
}
